module.exports = __webpack_public_path__ + "static/1.1.E.3 FORNA RANDARE 3-30298f4523e339c69ac55f2ebb1720a7.jpg";